.icon {
  border-radius: var(--radius-sm);
  object-fit: contain;
  flex-shrink: 0;
}

.fallback {
  border-radius: var(--radius-sm);
  background: var(--bg-elevated);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--weight-bold);
  color: var(--text-muted);
  flex-shrink: 0;
}
